import { InputFileInformationSelection } from './InputFileInformationSelection';
import { ContainerInputProps } from '../input-props';
import { InputLabelsMapFetcher } from '@/app/features/products/common/services/InputLabelsMapFetcher';
import { useDataStore } from '@/app/core/components/step-wizard';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { frontendProcessingValidator } from '@ssar-app/domain';
import { useEffect, useState } from 'react';

export const FrontEndProcessingContainer = (props: ContainerInputProps) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys } = props;
  const { data } = useDataStore();
  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);
  return (
    <>
      {subCode !== '' && (
        <InputLabelsMapFetcher
          subCode={subCode}
          onSuccess={(inputLabelsMap, isLoading) => {
            return (
              <InputFileInformationSelection
                stepKey={keys}
                moduleProps={{
                  productName: getCurrentFeatureCode() || '',
                  inputFileSelectionOptions: {
                    canSelectClientFile: false,
                    canSelectRemoteFile: true,
                  },
                  inputLabelsMap: inputLabelsMap,
                  isLoading: isLoading,
                }}
                validator={frontendProcessingValidator}
              />
            );
          }}
          onError={(error) => {
            console.error(error);
          }}
        />
      )}
    </>
  );
};
